module.exports = __webpack_public_path__ + "img/stability.d701c8e1.png";